import { FormApi } from 'final-form';
import { ApolloError } from '@apollo/client';

import { OfferFragment } from '@occc/graphql';
import { useOfferUpdateMutation } from '@occc-app/dataAccessLayer/offer/mutations';

import { isFieldDirty } from '../utils';
import { InitialFormValues } from '../types';

export const useGetInitialFormProps = (
  offerId: string,
  offer: OfferFragment | undefined,
  onCompleted: (isOfferUpdated: boolean) => Promise<void>,
  onError: (error: ApolloError) => void,
  onNextClick: () => void,
) => {
  const [offerUpdate, { loading: offerUpdateLoading }] = useOfferUpdateMutation({
    onError,
  });

  const onInitialPageFormSubmitted = async (
    values: InitialFormValues,
    form: FormApi<InitialFormValues>,
  ) => {
    const dirtyFields = form.getState().dirtyFields;
    let isOfferUpdated = false;

    if (
      isFieldDirty<InitialFormValues>(dirtyFields, 'name') ||
      isFieldDirty<InitialFormValues>(dirtyFields, 'description')
    ) {
      await offerUpdate({
        variables: {
          input: {
            id: offerId,
            name: values.name,
            description: values.description || null,
          },
        },
      });

      isOfferUpdated = true;
    }

    await onCompleted(isOfferUpdated);
  };

  const initialPageProps = {
    initialValues: {
      name: offer?.name,
      description: offer?.description || undefined,
    },
    onSubmit: onInitialPageFormSubmitted,
    loading: offerUpdateLoading,
    onNextClick,
  };

  return initialPageProps;
};
